<app-portal name="header-action">
  <ng-container *ngIf="createRoute && !createMenu">
    <button
      mat-flat-button
      color="accent"
      [routerLink]="createRoute"
      *hasPrivilege="createPrivilege"
    >
      New {{ nomenclature | nomenclature }}
    </button>
  </ng-container>

  <ng-container *ngIf="createRoute && createMenu">
    <button
      mat-flat-button
      color="accent"
      [matMenuTriggerFor]="newMenu"
      *hasPrivilege="createPrivilege"
    >
      New
      <mat-icon iconPositionEnd style="margin-left: 4px"
        >arrow_drop_down</mat-icon
      >
    </button>
    <mat-menu #newMenu="matMenu">
      <a
        mat-menu-item
        routerLink="/map/locations/create"
        *hasPrivilege="'remote_location/create'"
      >
        New {{ 'remote_location' | nomenclature }}
      </a>
      <a mat-menu-item [routerLink]="createRoute">
        New {{ nomenclature | nomenclature }}
      </a>
    </mat-menu>
  </ng-container>
</app-portal>

<iframe
  #iframe
  allow="geolocation"
  [src]="iframeUrl"
  sandbox="allow-scripts allow-popups allow-forms allow-same-origin allow-top-navigation allow-downloads allow-modals allow-popups-to-escape-sandbox"
></iframe>
